import { ObjectType } from "../types";

export const getFiscalYearLabel = (yearObject: ObjectType) => {
  return `${new Date(yearObject.startDate).getFullYear()} - ${new Date(
    yearObject.endDate
  ).getFullYear()}`;
};
